module.exports = __webpack_public_path__ + "img/google-play-badge-da.cf3ae170.png";